import { render, staticRenderFns } from "./TableDeliveryItemsByDestination.vue?vue&type=template&id=6ee10d3a&scoped=true&"
import script from "./TableDeliveryItemsByDestination.vue?vue&type=script&lang=js&"
export * from "./TableDeliveryItemsByDestination.vue?vue&type=script&lang=js&"
import style0 from "./TableDeliveryItemsByDestination.vue?vue&type=style&index=0&id=6ee10d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee10d3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
